import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import './iconsTooltipEditor.scss'
import shortId from 'shortid';

export interface IconsTooltipEditorProps {
  children?: any
  text: string
}

const IconsTooltipEditor: React.SFC<IconsTooltipEditorProps> = (props) => {
  return (
    <OverlayTrigger
      trigger={['click', 'focus', 'hover']}
      overlay={
        <Tooltip
          id={shortId.generate()}
        >
          {props.text}
        </Tooltip>
      }
    >
      {props.children}
    </OverlayTrigger>
  );
}

export default IconsTooltipEditor;
